import { UserManagementActionType } from '@modules/users/store/userManagementActionType';
import { UserState, UserType } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';

// new enum type to merge the two types from BE - UserType and UserState
export enum UserRowRoleType {
  Admin = 'Admin', // UserType.Manager
  Editor = 'Editor', // UserType.Editor
  Member = 'Member', // UserType.Member
  Viewer = 'Viewer', // UserType.Viewer

  SuperAdmin = 'SuperAdmin', // UserType.SuperManager
  SuperEditor = 'SuperEditor', // UserType.SuperEditor
  SuperMember = 'SuperMember', // UserType.SuperMember
  SuperViewer = 'SuperViewer', // UserType.SuperViewer

  Suspended = 'Suspended', // UserState.Suspended
}

export interface UserRow {
  id: UUID;
  name: string;
  email: string;
  role: UserRowRoleType;
  type: UserType;
  state: UserState;
}

export interface UserManagementState {
  users: UserRow[];
  isAutoApprovalDisabled: boolean;
  visual: {
    isFetchingUsers: boolean;
    isFetchingAutoApprovalState: boolean;
  };
}

interface UserManagementSetMembersDataAction {
  type: UserManagementActionType.SET_USERS_DATA;
  payload: { users: UserManagementState['users'] };
}

interface UserManagementSetVisualAction {
  type: UserManagementActionType.SET_VISUAL;
  payload: Partial<UserManagementState['visual']>;
}

interface UserManagementUpdateMemberAction {
  type: UserManagementActionType.UPDATE_USER;
  payload: { id: UUID; user: Partial<UserRow> };
}

interface UserManagementSetAutoApprovalStateAction {
  type: UserManagementActionType.SET_AUTO_APPROVAL_STATE;
  payload: {
    isAutoApprovalDisabled: UserManagementState['isAutoApprovalDisabled'];
  };
}

export type UserManagementAction =
  | UserManagementSetMembersDataAction
  | UserManagementUpdateMemberAction
  | UserManagementSetVisualAction
  | UserManagementSetAutoApprovalStateAction;
